import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faMapMarkerAlt, faStore } from '@fortawesome/free-solid-svg-icons';

export default function VendorCard({ vendor, onClick }) {
  const rating = vendor.averageRating || 0;
  const reviewCount = vendor.reviewCount || 0;
  const priceRange = vendor.priceRange;

  return (
    <div
      onClick={onClick}
      className="bg-white rounded-xl border-2 border-border p-6 cursor-pointer hover:border-primary hover:shadow-lg transition-all"
    >
      {/* Vendor Image */}
      <div className="w-full h-48 bg-gray-200 rounded-lg mb-4 overflow-hidden">
        {vendor.imageUrl ? (
          <img 
            src={vendor.imageUrl} 
            alt={vendor.name}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-primary/10 to-primary-light/10">
            <FontAwesomeIcon icon={faStore} className="text-4xl text-primary/30" />
          </div>
        )}
      </div>

      {/* Vendor Info */}
      <div>
        <h3 className="text-lg font-bold text-text-primary mb-2">{vendor.name}</h3>
        
        {/* Categories */}
        {vendor.categories && vendor.categories.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-3">
            {vendor.categories.slice(0, 2).map(category => (
              <span
                key={category}
                className="text-xs px-2 py-1 bg-primary/10 text-primary rounded-full font-semibold"
              >
                {category}
              </span>
            ))}
            {vendor.categories.length > 2 && (
              <span className="text-xs px-2 py-1 bg-gray-100 text-text-secondary rounded-full">
                +{vendor.categories.length - 2}
              </span>
            )}
          </div>
        )}

        {/* Rating */}
        <div className="flex items-center gap-2 mb-2">
          <div className="flex items-center gap-1">
            <FontAwesomeIcon icon={faStar} className="text-yellow-400" />
            <span className="font-semibold text-text-primary">{rating.toFixed(1)}</span>
          </div>
          {reviewCount > 0 && (
            <span className="text-sm text-text-secondary">
              ({reviewCount} {reviewCount === 1 ? 'review' : 'reviews'})
            </span>
          )}
        </div>

        {/* Location */}
        {vendor.location && (
          <div className="flex items-center gap-2 mb-3 text-sm text-text-secondary">
            <FontAwesomeIcon icon={faMapMarkerAlt} />
            <span>{vendor.location}</span>
          </div>
        )}

        {/* Price Range */}
        {priceRange && (
          <div className="text-sm font-semibold text-text-primary">
            {priceRange.min === priceRange.max ? (
              `$${priceRange.min.toLocaleString()}`
            ) : (
              `$${priceRange.min.toLocaleString()} - $${priceRange.max.toLocaleString()}`
            )}
          </div>
        )}

        {/* Description Preview */}
        {vendor.description && (
          <p className="text-sm text-text-secondary mt-3 line-clamp-2">
            {vendor.description}
          </p>
        )}
      </div>
    </div>
  );
}
